module.exports = __webpack_public_path__ + "img/income.b1edce0f.png";